// extracted by css-extract-rspack-plugin
export default {"label":"sfY3Jl","core-icon":"yBqFka","coreIcon":"yBqFka"};